
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#3q86davywa)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#2A333D"}},[_c('path',{attrs:{"d":"M1 21.023l22-.035.003 2-22 .035-.003-2zm2.992-5.005l3-.005.006 4-3 .005-.006-4zm9.997-2.016l3-.005.01 6-3 .005-.01-6zm-6.002-.99l3-.005.011 7-3 .005-.01-7zm9.995-3.016l3-.005.016 10-3 .005-.016-10zM15.97 1.999l5-.008.009 5-2 .003-.005-3-3 .005-.003-2z"}}),_c('path',{attrs:{"d":"M3.404 13.792L1.988 12.38 9.34 5.004l3.54 3.53 5.986-6.004 1.416 1.412-7.394 7.418-3.541-3.53-5.943 5.962z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"3q86davywa"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    